import { render } from "./BalTable.vue?vue&type=template&id=28b70144&ts=true"
import script from "./BalTable.vue?vue&type=script&lang=ts"
export * from "./BalTable.vue?vue&type=script&lang=ts"

import "./BalTable.vue?vue&type=style&index=0&id=28b70144&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__